/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useState } from 'react';
import * as S from './AssessmentFlags.styled';
import { getCountryFlag } from 'utils/fetchassets';
import { Program } from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/components/Results/Results';
import PrimaryModal from 'components/common/PrimaryModal/PrimaryModal';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { useTranslation } from 'react-i18next';
import { CountryCard } from '../../assessmentResultsCard/resultsCard';

interface AssessmentFlagsProps {
    programs: any[];
}

export default function AssessmentFlag({ programs }: AssessmentFlagsProps) {
    const [openProgramsDialog, setOpenProgramsDialogs] = useState<boolean>(false);
    const [selectedPrograms, setSelectedPrograms] = useState<any>([]);
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();

    const handleFlagClick = (program: Program) => {
        setOpenProgramsDialogs(true);
        setSelectedPrograms([program]);
    };

    const closeProgramsDialog = () => {
        setOpenProgramsDialogs(false);
        setSelectedPrograms(null);
    };

    return (
        <S.Container>
            <S.FlagsWrapper>
                {programs.map((program, index) => (
                    <S.FlagContainer key={index}>
                        <S.FlagImage
                            style={{ width: '40px', height: '30px' }}
                            src={
                                window.location.protocol +
                                '//' +
                                window.location.host +
                                getCountryFlag(program.flag)
                            }
                            alt={program.country}
                            onClick={() => handleFlagClick(program)}
                        />
                        {program.flag && <S.Notification>{program.streams.length}</S.Notification>}
                    </S.FlagContainer>
                ))}
            </S.FlagsWrapper>
            <PrimaryModal open={openProgramsDialog} onClose={closeProgramsDialog} maxWidth="640px">
                {selectedPrograms ? (
                    <S.Wrapper>
                        <S.Title>{t(`assessmentResults`, { lng: language })}</S.Title>
                        {selectedPrograms.map((country: any, idx: number) => (
                            <CountryCard key={idx} {...country} />
                        ))}
                    </S.Wrapper>
                ) : (
                    'No data'
                )}
            </PrimaryModal>
        </S.Container>
    );
}
